import React from 'react';

import { BackportingEnums } from '../../../../../../generated/compat/backportingEnums';
import { FinancialStatementInfo } from '../../../../../../generated/model/financialStatementInfo';
import MatrixDataTable from '../../shared/MatrixDataTable';

export interface Props {
  data?: FinancialStatementInfo[];
  ccy?: BackportingEnums.CcyEnum;
}

const TABLE_FIELDS = ['statementResources'];

const FinancialStatements: React.FC<Props> = ({ data, ccy }) => {
  return (
    <MatrixDataTable
      title={'financialStatements'}
      translationsScope={'companies:companyFinancials'}
      data={data}
      tableFields={TABLE_FIELDS}
      ccy={ccy}
    />
  );
};

export default FinancialStatements;
